
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "AAST_liver_trauma_classification",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/AAST_liver_trauma_classification.vue